import React from 'react';

import PropTypes from 'prop-types';
import Radio from '@tds/core-radio';

import Label from './label';
import { FieldOptionsGroup } from './css';
import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const DefectPriority = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: {
        labelPriority,
        labelPriorityOptionLow,
        labelPriorityOptionMedium,
        labelPriorityOptionHigh,
        labelPriorityOptionUrgent
      }
    }
  } = locale === 'en-US' ? EN : FR;

  const fieldError = 'priority' in formErrors;
  const fieldOptions = [
    labelPriorityOptionLow,
    labelPriorityOptionMedium,
    labelPriorityOptionHigh,
    labelPriorityOptionUrgent
  ];

  const handleSelect = ({ target: { value } }) => {
    if (value)
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.priority;
        return updatedValues;
      });
    setFieldData(previousValue => ({
      ...previousValue,
      priority: value
    }));
  };

  return (
    <div>
      <Label labelName={`${labelPriority} *`} />
      {fieldError && (
        <div className="error-notification">
          <p>{formErrors.priority.message}</p>
        </div>
      )}
      <FieldOptionsGroup>
        {fieldOptions.map(option => {
          return (
            <Radio
              checked={fieldData.priority === option}
              onChange={handleSelect}
              name="priority"
              value={option}
              label={option}
            />
          );
        })}
      </FieldOptionsGroup>
    </div>
  );
};

DefectPriority.propTypes = {
  formErrors: PropTypes.shape({
    priority: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectPriority;
